export interface getTabLeftScrollPxProps {
  // 실제로 화면에 보여지는 탭의 width
  tabWidthPx: number;
  // 탭 전체에 적용된 좌측 패딩 width
  tabLeftPaddingPx: number;
  // 탭 전체에 적용된 우측 패딩 width
  tabRightPaddingPx: number;
  // 탭 아이템을 정렬할 기준이 될 Tab의 centerX position 값
  tabCenterX: number;
  // 현재 선택된 탭 아이템의 centerX position 값
  currentItemCenterX: number;
  // overflow 된 아이템들을 포함한 전체 탭의 길이
  totalScrollWidthPx: number;
  // 탭이 촤즉 시작점으로부터 얼마나 우측으로 스크롤이 됐는지에 대한 값
  currentScrolledWidthPx: number;
  // 첫 번째 탭 아이템의 Width
  firstChildWidthPx: number;
  // 마지막 탭 아이템의 Width
  lastChildWidthPx: number;
}
/**
 * 탭 내부의 특정 항목이 활성화되었을 떄, 현재 상태를 기준으로
 * 얼마만큼 좌측으로 스크롤이 되어야 하는지에 대한 픽셀 값을 계산해주는 함수입니다.
 * 우측으로 스크롤해야 하는 경우 그 만큼의 픽셀 값을 음수로 반환합니다.
 */
export function getTabLeftScrollPx({
  tabWidthPx,
  tabLeftPaddingPx,
  tabRightPaddingPx,
  tabCenterX,
  currentItemCenterX,
  totalScrollWidthPx,
  currentScrolledWidthPx,
  firstChildWidthPx,
  lastChildWidthPx,
}: getTabLeftScrollPxProps): number {
  // 아이템을 단순 중앙 정렬하기 위해 스크롤해야 하는 픽셀 크기
  const scrollToAlignItemCenterPx = currentItemCenterX - tabCenterX;
  // 아이템을 중앙정렬 시켰을 때 스크롤 된 길이
  const scrolledWidthAfterScroll =
    currentScrolledWidthPx + scrollToAlignItemCenterPx;
  // 남은 스크롤 가능한 픽셀 크기
  const remainScrollableWidth =
    totalScrollWidthPx - (currentScrolledWidthPx + tabWidthPx);
  // 좌측 패딩을 포함한 첫 번째 아이템이 차지하는 영역
  const firstChildAreaPx = tabLeftPaddingPx + firstChildWidthPx;
  // 우측 패딩을 포함한 마지막 아이템이 차지하는 영역
  const lastChildAreaPx = tabRightPaddingPx + lastChildWidthPx;

  if (firstChildAreaPx > scrolledWidthAfterScroll) {
    return -currentScrolledWidthPx;
  } else if (
    lastChildAreaPx >
    remainScrollableWidth - scrollToAlignItemCenterPx
  ) {
    return remainScrollableWidth;
  } else {
    return scrollToAlignItemCenterPx;
  }
}
